import React from 'react'

const StaffCReport = () => {
 
       return (
    <iframe src='https://spintoss.twin-park.tn/Login' allowfullscreen style={{width: "100%", height: "1024px"}}/>
  )
}
   

export default StaffCReport
